var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTeamMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 300,
    viewBox: "0 0 331 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.005 0C81.1586 0 14 67.1586 14 149.995C14 232.832 81.1586 299.99 164.005 299.99C246.851 299.99 314 232.832 314 149.995C314 67.1586 246.841 0 164.005 0ZM164.005 291.598C126.181 291.598 90.6289 276.863 63.8829 250.127C37.1369 223.381 22.4117 187.819 22.4117 150.005C22.4117 112.191 37.1369 76.6289 63.8829 49.8829C90.6193 23.1273 126.181 8.40204 164.005 8.40204C201.828 8.40204 237.381 23.1273 264.127 49.8733C290.873 76.6193 305.598 112.172 305.598 149.995C305.598 187.819 290.873 223.371 264.127 250.117C237.381 276.853 201.828 291.588 164.005 291.588V291.598Z",
    fill: "url(#paint0_linear_318_5350)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M164.004 295.891C96.2677 295.891 38.9356 251.763 19.6484 190.918C37.4631 253.871 95.3438 299.991 164.004 299.991C232.664 299.991 290.535 253.871 308.349 190.918C289.062 251.763 231.73 295.891 164.004 295.891Z",
    fill: "url(#paint1_linear_318_5350)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.966 47.0321C239.46 19.5354 202.897 4.38672 164.005 4.38672C125.113 4.38672 88.55 19.5354 61.0437 47.0418C33.5374 74.5385 18.3887 111.111 18.3887 149.993C18.3887 188.876 33.5374 225.448 61.0341 252.954C88.5404 280.451 125.113 295.6 163.995 295.6C202.877 295.6 239.45 280.451 266.956 252.954C294.453 225.458 309.602 188.885 309.602 149.993C309.602 111.101 294.453 74.5385 266.956 47.0321H266.966ZM264.127 250.115C237.381 276.852 201.828 291.586 164.005 291.586C126.181 291.586 90.6289 276.852 63.8829 250.115C37.1369 223.369 22.4116 187.807 22.4116 149.993C22.4116 112.179 37.1369 76.6173 63.8829 49.8713C90.6193 23.1253 126.181 8.40006 164.005 8.40006C201.828 8.40006 237.381 23.1253 264.127 49.8713C290.873 76.6173 305.598 112.17 305.598 149.993C305.598 187.817 290.873 223.369 264.127 250.115Z",
    fill: "url(#paint2_linear_318_5350)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M308.349 109.073C290.535 46.1198 232.654 0 164.004 0C95.3534 0 37.4631 46.1198 19.6484 109.073C38.9356 48.2371 96.2677 4.52344 164.004 4.52344C231.74 4.52344 289.062 48.2275 308.349 109.073Z",
    fill: "url(#paint3_linear_318_5350)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 129L40 149L20 169L0 149L20 129ZM20 136.482L7.47031 149.012L20 161.542L32.5297 149.012L20 136.482Z",
    fill: "url(#paint4_linear_318_5350)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74109 149L20 132.741V129L0 149H3.74109Z",
    fill: "url(#paint5_radial_318_5350)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0011 132.742L3.74219 149.001H7.48328L20.0011 136.483V132.742Z",
    fill: "url(#paint6_linear_318_5350)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2589 149L20 132.741V129L40 149H36.2589Z",
    fill: "url(#paint7_linear_318_5350)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 132.742L36.2589 149.001H32.5297L20 136.483V132.742Z",
    fill: "url(#paint8_linear_318_5350)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74109 149L20 165.271V169L0 149H3.74109Z",
    fill: "url(#paint9_linear_318_5350)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0011 165.271L3.74219 149H7.48328L20.0011 161.53V165.271Z",
    fill: "url(#paint10_linear_318_5350)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2941 149L20.0352 165.271V169L40.0352 149H36.2941Z",
    fill: "url(#paint11_linear_318_5350)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 165.271L36.2589 149H32.5297L20 161.53V165.271Z",
    fill: "url(#paint12_linear_318_5350)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0102 136.484L7.48047 149.014L20.0102 161.544L32.5398 149.014L20.0102 136.484Z",
    fill: "#9A9999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49219 149.002L20.0219 136.484L32.5397 149.002L20.0219 161.532L7.49219 149.002Z",
    fill: "url(#paint13_linear_318_5350)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9453 149.002L20.0213 140.938L28.0855 149.002L20.0213 157.078L11.9453 149.002Z",
    fill: "url(#paint14_linear_318_5350)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9968 148.94L20.0609 140.876V136.422L7.53125 148.94H11.9968Z",
    fill: "url(#paint15_linear_318_5350)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0876 149.002L20.0234 140.938V136.484L32.5413 149.002H28.0876Z",
    fill: "url(#paint16_linear_318_5350)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9459 148.984L20.0219 157.049V161.502L7.49219 148.984H11.9459Z",
    fill: "url(#paint17_linear_318_5350)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0876 148.984L20.0234 157.049V161.502L32.5413 148.984H28.0876Z",
    fill: "url(#paint18_linear_318_5350)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310 129L330 149L310 169L290 149L310 129ZM310 136.482L297.47 149.012L310 161.542L322.53 149.012L310 136.482Z",
    fill: "url(#paint19_linear_318_5350)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.741 149L310 132.741V129L290 149H293.741Z",
    fill: "url(#paint20_radial_318_5350)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.001 132.742L293.742 149.001H297.483L310.001 136.483V132.742Z",
    fill: "url(#paint21_linear_318_5350)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.259 149L310 132.741V129L330 149H326.259Z",
    fill: "url(#paint22_linear_318_5350)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310 132.742L326.259 149.001H322.53L310 136.483V132.742Z",
    fill: "url(#paint23_linear_318_5350)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.741 149L310 165.271V169L290 149H293.741Z",
    fill: "url(#paint24_linear_318_5350)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.001 165.271L293.742 149H297.483L310.001 161.53V165.271Z",
    fill: "url(#paint25_linear_318_5350)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.294 149L310.035 165.271V169L330.035 149H326.294Z",
    fill: "url(#paint26_linear_318_5350)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310 165.271L326.259 149H322.53L310 161.53V165.271Z",
    fill: "url(#paint27_linear_318_5350)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.01 136.484L297.48 149.014L310.01 161.544L322.54 149.014L310.01 136.484Z",
    fill: "#9A9999"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.492 149.002L310.022 136.484L322.54 149.002L310.022 161.532L297.492 149.002Z",
    fill: "url(#paint28_linear_318_5350)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.945 149.002L310.021 140.938L318.085 149.002L310.021 157.078L301.945 149.002Z",
    fill: "url(#paint29_linear_318_5350)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.997 148.94L310.061 140.876V136.422L297.531 148.94H301.997Z",
    fill: "url(#paint30_linear_318_5350)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.088 149.002L310.023 140.938V136.484L322.541 149.002H318.088Z",
    fill: "url(#paint31_linear_318_5350)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.946 148.984L310.022 157.049V161.502L297.492 148.984H301.946Z",
    fill: "url(#paint32_linear_318_5350)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.088 148.984L310.023 157.049V161.502L322.541 148.984H318.088Z",
    fill: "url(#paint33_linear_318_5350)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_5350",
    x1: 164.005,
    y1: 0,
    x2: 164.005,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_5350",
    x1: 164.004,
    y1: 190.918,
    x2: 164.004,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_5350",
    x1: 164.005,
    y1: 295.609,
    x2: 164.005,
    y2: 4.38672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_5350",
    x1: 164.004,
    y1: 109.073,
    x2: 164.004,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_5350",
    x1: 0,
    y1: 149,
    x2: 40,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_318_5350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10 139) scale(10)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_5350",
    x1: 3.74219,
    y1: 140.866,
    x2: 20.0011,
    y2: 140.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_5350",
    x1: 20,
    y1: 139,
    x2: 40,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_5350",
    x1: 20,
    y1: 140.866,
    x2: 36.2589,
    y2: 140.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57688E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98ADDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_5350",
    x1: 0,
    y1: 159,
    x2: 20,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_5350",
    x1: 3.74219,
    y1: 157.135,
    x2: 20.0011,
    y2: 157.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_5350",
    x1: 20.0352,
    y1: 159,
    x2: 40.0352,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_5350",
    x1: 20,
    y1: 157.135,
    x2: 36.2589,
    y2: 157.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_5350",
    x1: 7.49219,
    y1: 149.002,
    x2: 32.5397,
    y2: 149.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_5350",
    x1: 11.9453,
    y1: 149.002,
    x2: 28.0855,
    y2: 149.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_5350",
    x1: 7.53125,
    y1: 142.681,
    x2: 20.0609,
    y2: 142.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_5350",
    x1: 20.0234,
    y1: 142.743,
    x2: 1.18734,
    y2: 142.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_5350",
    x1: -0.001875,
    y1: 155.243,
    x2: 20.0219,
    y2: 155.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_318_5350",
    x1: 26.2823,
    y1: 155.243,
    x2: 24.0496,
    y2: 153.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A92C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A65A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_318_5350",
    x1: 290,
    y1: 149,
    x2: 330,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_318_5350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(300 139) scale(10)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_318_5350",
    x1: 293.742,
    y1: 140.866,
    x2: 310.001,
    y2: 140.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_318_5350",
    x1: 310,
    y1: 139,
    x2: 330,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_318_5350",
    x1: 310,
    y1: 140.866,
    x2: 326.259,
    y2: 140.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57688E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98ADDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_318_5350",
    x1: 290,
    y1: 159,
    x2: 310,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_318_5350",
    x1: 293.742,
    y1: 157.135,
    x2: 310.001,
    y2: 157.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_318_5350",
    x1: 310.035,
    y1: 159,
    x2: 330.035,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_318_5350",
    x1: 310,
    y1: 157.135,
    x2: 326.259,
    y2: 157.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_318_5350",
    x1: 297.492,
    y1: 149.002,
    x2: 322.54,
    y2: 149.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_318_5350",
    x1: 301.945,
    y1: 149.002,
    x2: 318.085,
    y2: 149.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_318_5350",
    x1: 297.531,
    y1: 142.681,
    x2: 310.061,
    y2: 142.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_318_5350",
    x1: 310.023,
    y1: 142.743,
    x2: 291.187,
    y2: 142.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_318_5350",
    x1: 289.998,
    y1: 155.243,
    x2: 310.022,
    y2: 155.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_318_5350",
    x1: 316.282,
    y1: 155.243,
    x2: 314.05,
    y2: 153.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A92C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A65A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTeamMember);
export default __webpack_public_path__ + "static/media/circle-team-member.ec13bb9cd4abfbbc5a9324297b205a6d.svg";
export { ForwardRef as ReactComponent };